module.exports = __webpack_public_path__ + "static/img/03.e9a3a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-assetsM/03.jpg
// module id = ixkg
// module chunks = 1